import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BookingFlow from "@/components/BookingFlow";
import { trackBooking } from "@/lib/analytics";

export default function TripPage() {
  const { id } = useParams();
  const [q] = useSearchParams();
  const nav = useNavigate();
  return (
    <div className="hero-bg min-h-full">
      <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6">
        <button onClick={() => nav(-1)} className="mb-4 flex items-center gap-1 text-sm font-semibold text-slate-600 hover:text-[#0052FF]" data-testid="trip-back-button">
          <ArrowLeft className="h-4 w-4" /> Back to buses
        </button>
        <h1 className="mb-5 font-display text-2xl font-extrabold tracking-tight sm:text-3xl">Choose your seats</h1>
        <BookingFlow tripId={id} from={q.get("from")} to={q.get("to")} onBooked={(b) => { trackBooking(); nav(`/ticket/${b.code}`); }} />
      </div>
    </div>
  );
}
